<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Orders Billed/Invoiced Details Report</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
        <div *ngIf="isModal">
          <i class="pi pi-times" (click)="closeModalEventFunction()"></i>
        </div>
      </span>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="filterOrdersInvoicedDetailsDetailLists"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="filterOrdersInvoicedDetailsDetailLists.length >= 50"
          (onFilter)="onFilter($event)"
          stripedRows
          [rowHover]="true"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Invoice#</th>
              <th>Invoice Date</th>
              <th>Client</th>
              <th>Sale Order #</th>
              <th>Client PO</th>
              <th>Job Name</th>
              <th>Total Sell</th>
              <th>Base Comm</th>
              <th>Order GP%</th>
              <th>Billed Freight</th>
              <th>Billed Tax</th>
              <th>Invoice Total</th>
              <th>Prepay</th>
              <th>Invoice Balance</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="invoiceNumber"
                    id="invoiceNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'invoiceNumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <!-- <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                name="invoiceDate"
                id="invoiceDate"
                class="date-filter"
                onfocus="(this.type='date')"
                onblur="if(!this.value) this.type='text'"
                (change)="onInvoiceDateFilter($event)"
              />
            </div> -->
                <jni-date-filter
                  [dataList]="ordersInvoicedDetailsDetailLists"
                  [columnName]="invoiceDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customer"
                    id="customer"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customer',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderNumber"
                    id="salesOrderNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderNumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerPO"
                    id="customerPO"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerPO',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="jobName"
                    id="jobName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'jobName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-ordersInvoicedDetailsDetailList
            let-rowIndex="rowIndex">
            <tr class="p-selectable-row">
              <td>
                <a
                  class="link"
                  (click)="
                    getInvoiceReport(
                      ordersInvoicedDetailsDetailList.invoiceNumber
                    )
                  ">
                  {{ ordersInvoicedDetailsDetailList.invoiceNumber }}
                </a>
              </td>
              <td>
                {{
                  ordersInvoicedDetailsDetailList.invoiceDate
                    | date: "MM-dd-yyyy"
                }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(ordersInvoicedDetailsDetailList.customerId)
                  ">
                  {{ ordersInvoicedDetailsDetailList.customer }}
                </a>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToSaleorder(
                      ordersInvoicedDetailsDetailList.salesOrderNumber
                    )
                  ">
                  {{ ordersInvoicedDetailsDetailList.salesOrderNumber }}
                </a>
              </td>

              <td>
                {{ ordersInvoicedDetailsDetailList.customerPO }}
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.jobName }}
              </td>
              <td>
                <span *ngIf="showTotalSell">
                  {{ ordersInvoicedDetailsDetailList.totalSell | currency }}
                </span>

                <span *ngIf="!showTotalSell">
                  {{
                    ordersInvoicedDetailsDetailList.subTotalAmount | currency
                  }}
                </span>
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.baseCommission | currency }}
              </td>
              <td>
                {{
                  ordersInvoicedDetailsDetailList.orderGPPercentage | currency
                }}
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.billedFreight | currency }}
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.billedTax | currency }}
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.billedTotal | currency }}
              </td>
              <td>
                {{ ordersInvoicedDetailsDetailList.prepay | currency }}
              </td>

              <td>
                {{ ordersInvoicedDetailsDetailList.balance | currency }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      (closeOrderSummaryModalEvent)="closeModalForSaleOrder()"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      [isModal]="true"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
